var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65625 5V19H3V5H3.65625ZM21.6667 5V19H21.0104V5H21.6667ZM4.3125 5V18.99H3.97916V5H4.3125ZM5.29166 5V18.99H4.96875V5H5.29166ZM6.92707 5V18.99H6.60416V5H6.92707ZM8.56248 5V18.99H7.91666V5H8.56248ZM9.87498 5V18.99H9.55207V5H9.87498ZM10.5312 5V18.99H10.2083V5H10.5312ZM11.1875 5V18.99H10.8646V5H11.1875ZM12.8229 5V18.99H12.1667V5H12.8229ZM14.4583 5V18.99H13.8021V5H14.4583ZM15.7708 5V18.99H15.1146V5H15.7708ZM17.0834 5V18.99H16.4271V5H17.0834ZM18.0625 5V18.99H17.4063V5H18.0625ZM20.0313 5V18.99H19.0521V5H20.0313ZM20.6875 5V18.99H20.3542V5H20.6875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.9475e6577958c514218a5a85d98a35af.svg";
export { ForwardRef as ReactComponent };